import React, { useState } from "react";
import axios from "axios";
import api from '../utils/api';


const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleRecover = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    setError("");

    try {
      const response = await api.post(
        `${process.env.REACT_APP_API_BASE_URL}/users/forgot-password`, // Use the environment variable
        { email } // Pass the email as payload
      );

      if (response.status === 200) {
        setMessage(
          response.data.message || "Password recovery instructions sent to your email address"
        );
      }
    } catch (err) {
      console.error("Error during password recovery:", err);
      setError(err.response?.data?.message || "An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-black">
      <div className="text-black p-8 rounded-lg shadow-md w-full max-w-md bg-primary">
        {/* Title */}
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-4">
          Reset Password
        </h2>
        <p className="text-gray-600 text-center mb-6">
          Enter your email address to recover your password.
        </p>

        {/* Form */}
        <form onSubmit={handleRecover} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Enter your email"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring focus:ring-blue-200"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className={`w-full bg-black text-primary font-bold py-2 rounded-lg transition duration-200 ${loading ? "opacity-50 cursor-not-allowed" : "hover:bg-white hover:text-black"
              }`}
          >
            {loading ? "Sending..." : "Recover"}
          </button>
        </form>

        {/* Success or Error Messages */}
        {message && (
          <p className="mt-4 text-green-600 text-center font-medium">{message}</p>
        )}
        {error && (
          <p className="mt-4 text-red-600 text-center font-medium">{error}</p>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
